import { createFileRoute } from '@tanstack/react-router';

import { DoctoralCommitteeCreate } from '@/module/Author/DoctoralCommittee/DoctoralCommitteeCreate';

export const Route = createFileRoute('/_auth/author/_author/doctoral-committee/_doctoralCommittee/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <DoctoralCommitteeCreate />;
}
